var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-kanban-board", attrs: { id: "project-kanban" } },
    [
      _c(
        "div",
        { staticClass: "kanban-rail", attrs: { id: "kanban-container" } },
        [
          _vm.cards.unknown.length
            ? _c(
                "section",
                {
                  staticClass: "kanban-column unknown-column",
                  attrs: { id: "id.unknown" }
                },
                [
                  _c("header", { staticClass: "unknown-header" }, [
                    _c("span", { staticClass: "column-dot" }),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("projects.no-status")))
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.cards.unknown.length))])
                  ]),
                  _c(
                    "draggable",
                    {
                      staticClass: "draggable-container",
                      attrs: {
                        disabled: _vm.readOnly,
                        id: "unknown",
                        list: _vm.cards.unknown,
                        group: { name: "card", pull: "clone" },
                        tag: "div",
                        "empty-insert-threshold": 100,
                        animation: 200,
                        handle: _vm.$store.state.isMobile
                          ? "disabled"
                          : ".cardWrapper",
                        "ghost-class": "ghost",
                        move: _vm.cardDragHandler
                      },
                      on: { end: _vm.endDragHandler }
                    },
                    _vm._l(_vm.cards.unknown, function(deliverable) {
                      return _c(
                        "div",
                        {
                          key: deliverable.id,
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.editDeliverable(deliverable)
                            }
                          }
                        },
                        [
                          _c("kanban-card", {
                            attrs: {
                              deliverable: deliverable,
                              "assignable-users": _vm.assignableUsers,
                              "status-list": _vm.columns,
                              "show-status": false
                            },
                            on: {
                              "edit-subtask": function($event) {
                                return _vm.editDeliverable($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._l(_vm.columns, function(column) {
            return _c(
              "section",
              {
                key: column.id,
                staticClass: "kanban-column",
                style: {
                  borderTopColor: column.hexColor || "var(--portal-border)"
                },
                attrs: { id: "id." + column.id }
              },
              [
                _c("kanban-header", {
                  attrs: {
                    column: column,
                    count: _vm.cardCount(column.id),
                    "allow-add-deliverable": _vm.hasFullAccessProjects
                  },
                  on: {
                    "add-deliverable": function($event) {
                      return _vm.addDeliverableNoWait($event)
                    }
                  }
                }),
                _c(
                  "draggable",
                  {
                    class:
                      "draggable-container " +
                      (_vm.$store.state.isMac ? "hidden-scroll" : ""),
                    attrs: {
                      disabled: _vm.readOnly,
                      list: _vm.cards["id" + column.id],
                      group: { name: "card", pull: "clone" },
                      tag: "div",
                      "empty-insert-threshold": 100,
                      animation: 200,
                      handle: _vm.$store.state.isMobile
                        ? "disabled"
                        : ".cardWrapper",
                      "ghost-class": "ghost",
                      move: _vm.cardDragHandler
                    },
                    on: { end: _vm.endDragHandler }
                  },
                  _vm._l(_vm.cards["id" + column.id], function(deliverable) {
                    return _c(
                      "div",
                      {
                        key: deliverable.id || "empty",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            deliverable.emptyCard
                              ? null
                              : _vm.editDeliverable(deliverable)
                          }
                        }
                      },
                      [
                        _c("kanban-card", {
                          attrs: {
                            deliverable: deliverable,
                            "assignable-users": _vm.assignableUsers,
                            "status-list": _vm.columns
                          },
                          on: {
                            "add-new-empty": function($event) {
                              return _vm.addDeliverableNoWait(column)
                            },
                            "edit-subtask": function($event) {
                              return _vm.editDeliverable($event)
                            },
                            "add-subtask": function($event) {
                              return _vm.addSubTask(deliverable)
                            }
                          }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              ],
              1
            )
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }